export default __webpack_public_path__ + "static/media/SDM.5101035f.png";